import axios from "../axios.config";

const state = {
  automation_list: []
};

const actions = {
  async loadAutomation({ commit }) {
    try {
      const { data } = await axios.get("/automation/");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_AUTOMATION_LIST", data);
    } catch (error) {
      throw new Error(error);
    }
  }
};

const mutations = {
  SET_AUTOMATION_LIST: (state, automation_list) => {
    state.automation_list = automation_list;
  }
};

const getters = {
  getProvider: state => {
    return [...state.automation_list];
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
